import Banner from "../../components/Banner";
import FAQSection from "../../components/FaqSection";
import Footer from "../../layout/Footer";
import Header1 from "../../layout/Header1";

function FAQ() {
    const votingProcess = [
        {
          title: "Do Voters Need Identification To Vote In Person?",
          description: "Yes. Voters need to bring an approved form of identification to vote at the Vote Center. <a href='https://www.harrisvotes.com/Voter/ID' target='_blank'  class='text-blue-300 underline'>Click here to find a list of the approved forms of voting identification.</a>"
        },
        {
          title: "What If A Voter Does Not Possess An Acceptable Form Of Voter Identification?",
          description: "Voters who do not possess an acceptable form of photo ID or a supporting document have the option of voting via a <a href='https://www.harrisvotes.com/Voter/Provisional-Limited-Ballots' target='_blank' class='text-blue-300 underline'>Provisional Ballot</a>. The Provisional Ballot must be cured within the 6 days following the election."
        },
        {
            title: "Are Cell Phones Permitted In The Vote Centers?",
            description: "People are not allowed to use a wireless communications device within 100 feet of the voting stations. Additionally, people are not allowed to use a mechanical or electronic device to record sound or images within 100 feet of the voting stations. Said devices include but are not limited to cell phones, digital phones, cameras, phone cameras and sound recorders.  The election judge has the authority to require persons to deactivate any such device and further authority to require persons who do not comply to leave the Vote Center."
        },
        {
            title: "Is There Straight Party Voting?",
            description: "The straight-party voting option (straight-ticket) was outlawed in 2020 after a bill was signed by Governor Greg Abbott in 2017."
        },
        {
            title: "What If A Voter Has A Concern While In The Process Of Voting?",
            description: "If a voter has a question while in the voting booth, the voter should notify an election worker."
        },
        {
            title: "Can A Person With Disabilities Vote At The Vote Center?",
            description: "Yes. Voting equipment allows disable voters to vote independently. Voters physically unable to enter the Vote Center may also request to be allowed to vote at the “curbside” outside the Vote Center. <a href='https://www.harrisvotes.com/Voter/Voters-with-Disabilities' target='_blank' class='text-blue-300 underline'>Click here to learn more.</a>"
        },
        {
            title: "In Texas, Does A Voter Have To Register By/with A Political Party To Vote?",
            description: "No. Voters do not have to register with a political party. However, during a Primary voters will have to choose which party they would like to participate in."
        },
        {
            title: "Is Electioneering Allowed Within The Vote Center?",
            description: "No. During the time a Vote Center is open for the conduct of voting, a person may not electioneer for or against any candidate, measure, or political party in or within 100 feet of an outside door through which a voter may enter the building or structure in which the Vote Center is located."
        },
        {
            title: "How Does A Voter Know Their Vote Was Cast?",
            description: "Take your printed ballot to the ballot scanner and insert it into the scanner. Your ballot is cast when you see the American Flag display on the screen.  "
        },
        {
            title: "Can A Voter Bring Someone To The Vote Center To Assist With The Voting Process?",
            description: "Yes. On the voter's request, the voter may be assisted by any person selected by the voter other than the voter's employer, an agent of the voter's employer, or an officer or agent of a labor union to which the voter belongs. "
        },
        {
            title: "What Is A Declaration Of Reasonable Impedement?",
            description: "A Declaration of Reasonable Impediment is a document that eligible registered voters who do not possess an acceptable form of photo identification must complete and provide a supporting document to cast a regular ballot. <a href='https://www.harrisvotes.com/Voter#identification-required-for-voting' target='_blank' class='text-blue-300 underline'>Click here to learn more.</a>"
        },
    ];
    const earlyVoting = [
        {
          title: "When Can I Apply To Vote By Mail? Is There A Deadline?",
          description: `
            <div>By April 22, in order to send you a mail ballot for the May 3 Election.</div>

            <div>You can also drop off your application in-person to any of our 10 offices with a valid photo identification. <a href='https://www.harrisvotes.com/Contact-Us' target='_blank'  class='text-blue-300 underline'>Click here to find an election's office near you</a>.</div>
            
            <div>Due to potential delays with the postal service, PLEASE DO NOT WAIT – APPLY NOW!</div>
          `
        },
        {
            title: "Who Is Eligible To Vote Early By Personal Appearance?",
            description: `Any qualified voter may vote early by personal appearance. No reason is needed.`
        },
        {
            title: "What Does Early Voting By Personal Appearance Mean?",
            description: `Early Voting By Personal Appearance means that a registered voter in Texas may vote prior to General Election Day during a period designated by state law.`
        },
        {
            title: "Why Was The Period For Early Voting By Personal Appearance Established?",
            description: `Early Voting by Personal Appearance was introduced in Texas in the mid-1990s to 
                make voting more convenient for the citizenry. It also provides voters who may be away 
                from the county of residence on Election Day the opportunity to vote in person. `
        },
        {
            title: "How Are The Early Voting Sites Designated?",
            description: `By law, in counties with a population of 400,000 or more, the commissioners’ court has the authority to establish at least one early voting site at each state representative district.`
        },
        {
            title: "Where Can A Registered Voter In Harris County Vote During The Early Voting Period?",
            description: `Any qualified voter may vote in person at the main Early Vote Center or at any other designated Early Voting branch location during designated times. <a href='https://www.harrisvotes.com/Polling-Locations' target='_blank' class='text-blue-300 underline'>Click here</a> to find Early Voting locations.`
        },
        {
            title: "When Does Early Voting By Personal Appearance Take Place?",
            description: `
              <div>
                  Texas Election Code: Sec. 85.001. EARLY VOTING PERIOD.
              </div>
              <div class='mt-3'>
                General Election: During a General Election the period for early voting by personal 
                appearance begins on the 17th day before Election Day and continues through the 
                fourth day before Election Day, except as otherwise provided. 
              </div>
              <div class='mt-3'>
                Runoff Election: The Early Voting Period for a special runoff election for the office of 
                state senator or state representative or for a runoff primary election begins on the 10th 
                day before election day.
              </div>
                <div class='mt-3'>
                    If the date prescribed by Subsection (a) or (b) for beginning the period is a Saturday, 
                    Sunday, or legal state holiday, the early voting period begins on the next regular 
                    business day. 
                </div>
            `
          },
    ];
    const electionDay = [
        {
            title: "Who Is Eligible to Vote?",
            description: `
                Registered voters in Harris County are eligible to vote. To register or check the status of your registration <a href='https://www.hctax.net/Voter/Registration' target='_blank' class='text-blue-300 underline'>click here</a>
            `
        },
        {
            title: "When Is Election Day?",
            description: `
                <div class='font-bold mb-3'>2025 Election Dates</div>
                <div class='mb-2'>
                    <span class='font-semibold'>Saturday, May 3, 2025</span> - Uniform & School Board Election 
                    <div class='text-sm italic'>(NOTE: Spring Branch ISD election is run by Spring Branch ISD)</div>
                </div>
                <div class='mb-2'>Saturday, June 14, 2025 - Runoff Election</div>
                <div class='mb-2'><span class='font-semibold'>Tuesday, November 4, 2025 </span> - Joint General & Special Election including School Board</div>
                <div class='mb-2'>Saturday, December 13, 2025 - Joint Runoff Election</div>
    
                <div class='font-bold mt-5 mb-3'>2026 Election Dates (potential dates)</div>
                <div class='mb-2'><span class='font-semibold'>Tuesday, March 3, 2026</span> - Primary Election</div>
                <div class='mb-2'>Saturday, May 2, 2026 – Uniform Election (Limited) (May have a runoff election)</div>
                <div class='mb-2'>Tuesday, May 26, 2026 – Primary Runoff Election</div>
                <div class='mb-2'><span class='font-semibold'>Tuesday, November 3, 2026</span> – Uniform Election Date</div>
                <div class='mb-2'>Saturday, December 12, 2026 – Uniform Runoff Election</div>
            `
        },
        {
            title: "What Contests Are on the Ballot?",
            description: `
                To view what contests will be on your ballot <a href='https://www.harrisvotes.com/sampleballots' target='_blank' class='text-blue-300 underline'>click here</a> to view your sample ballot.
            `
        },
        {
            title: "What Are the Vote Center Hours on Election Day?",
            description: `
                Election Day Vote Centers are open from 7AM to 7PM.
            `
        },
        {
            title: "May a Voter Participate in a General Election Even if the Voter Did Not Vote in the Primary Elections?",
            description: `
                Yes. It is not necessary to have voted in the Primary or Primary Runoff to vote in the General Election
            `
        },
        {
            title: "Is There Straight Party Voting?",
            description: `
                The straight-party voting option (straight-ticket) will be NO LONGER available beginning in 2020 under a bill Governor Greg Abbott signed in 2017
            `
        },
        {
            title: "Does a Voter Have to Vote for Candidates Affiliated with the Same Political Party of the Primary in Which They Voted?",
            description: `
                No
            `
        }
    ];

    const votingByMail = [
        {
            title: "How Do I Submit My Application to Vote by Mail?",
            description: `
                An application to Vote by Mail can be submitted in any of the following manners:
                <ol class='list-decimal pl-6 mb-2'>
                    <li>Regular residential mail via United States Postal Service;</li>
                    <li>Common or contract carrier (e.g., personal courier, FedEx, UPS, or other contracted mail service); or</li>
                    <li>Fax machine (713.755.4983) or e-mail (<a href='mailto:vbm@HarrisVotes.com' target='_blank' class='text-blue-300 underline'>vbm@HarrisVotes.com</a>). If you choose this option, the Harris County Clerk's Office Elections Department MUST receive your original, completed paper application by one of the above methods within four (4) business days of your email or fax.</li>
                </ol>
            `
        },
        {
            title: "Does My Vote by Mail Ballot Need Stamps?",
            description: `
                Yes, you will need two standard stamps when mailing your ballot ($1.10 total postage). If you do not have stamps, you may place your ballot in the mail without postage, and it will still be delivered to our office and counted.
            `
        },
        {
            title: "When Will I Get My Vote by Mail Ballot?",
            description: `
                <div>Domestic ballots will begin to be mailed out 6-8 weeks before the Election for those who have submitted applications by that time. If you submit an application after that time, your ballot will be mailed out within seven (7) days of your application being received.</div>
                
                <div class='mt-3'>Voters outside the United States: Your ballots will be mailed on or before the 45th day before Election Day, or within seven (7) days of your application being received.</div>
            `
        },
        {
            title: "Can I Vote in Person If I Received a Vote by Mail Ballot?",
            description: `
                You may vote in person even if you applied for a Vote by Mail ballot, but you can only vote once. To vote in person, take your Vote by Mail ballot to a voting center to surrender it and receive a regular ballot. If you do not have the mail ballot with you, you may still vote in person using a provisional ballot.
            `
        },
        {
            title: "Are There Different Deadlines If I Am Overseas or Serving in the Military?",
            description: `
                All ballots being returned in person must be received by 7:00 PM. on Election Day. If you are overseas and returning your ballot through the mail or a common or contract carrier, our office must receive it by 5 PM., five days after Election Day. If you are serving in the military and returning your ballot through the mail or a common or contract carrier, our office must receive it by 5 PM., six days after Election Day.
            `
        },
        {
            title: "How Do I Return My Completed Ballot to the Election Office? Is there a deadline?",
            description: `
                A completed mail ballot MUST be returned to the Harris County Clerk's Office Elections Department in the Official Carrier Envelope provided to you. It may be returned in any of the following manners:
                
                <ul class='list-disc pl-6 mb-2' style="list-style-type: number;">
                    <li>Regular residential mail via United States Postal Service:
                        <ul style="list-style-type: lower-roman;" class='ml-10'>
                            <li>Ballot must be postmarked by 7 PM on Election Day and must be received by 5 PM on the first mail delivery day after Election Day</li>
                            <li>In-person drop off at Harris County Clerk's Office Elections Department 1001 Preston Street Houston, TX 77002 on Election Day only from 7 AM – 7 PM.  </li>
                            <li>You must present an acceptable form of <a href='https://www.sos.state.tx.us/elections/forms/id/poster-8.5x14-aw-voter.pdf' target='_blank' class='text-blue-300 underline'>photo identification.</a> </li>
                            <li>If a voter does not possess and cannot reasonably obtain an acceptable form of photo identification, the voter <a href='https://www.sos.state.tx.us/elections/forms/id/poster-8.5x14-aw-voter.pdf' target='_blank' class='text-blue-300 underline'>may show a List B identification</a> and complete a Reasonable Impediment Declaration (RID)   </li>
                            <li>Only the voter may deliver their ballot in person</li>
                        </ul>
                    </li>
                    <li>Common or contract carrier; such as personal courier, or FedEx or UPS, or other contracted mail service
                        <ul style="list-style-type: lower-roman;" class='ml-10'>
                            <li>Ballot must be received by 7:00 PM. on Election Day</li>
                            <li>If the carrier provides receipt mark indicating a time before 7:00 PM. on Election Day, it may be received by 5:00 PM. on the first mail delivery day after Election Day. </li>
                        </ul>
                    </li>
                </ul>
            `
        },
        {
            title: "What If I'm Not Registered to Vote?",
            description: `
                <div>You can check your voting status at <a href='https://www.vote411.org/' target='_blank' class='text-blue-300 underline'>Vote411.org</a>.</div>
                <div>
                    To register to vote, there are currently two Texas organizations that will assist you with your registration remotely, <a href='https://register2vote.org/' target='_blank' class='text-blue-300 underline'>Register2Vote.org</a> and <a href='https://lwvhouston.org/' target='_blank' class='text-blue-300 underline'>The League of Women Voters - Houston</a>. Both of these organizations will supply you with a no contact, postage-paid voter registration card.
                </div>
                
            `
        },
        {
            title: "Do I Have to Apply to Vote by Mail for Each Election?",
            description: `
                If you are 65 years of age or older, or have a disability, you can apply for an annual ballot – this means that your Vote by Mail option will be registered for that entire calendar year. You will need to <a href='https://statutes.capitol.texas.gov/Docs/EL/htm/EL.86.htm' target='_blank' class='text-blue-300 underline'>reapply each calendar year</a> for an annual Vote by Mail ballot.
            `
        },
        {
            title: "Where Can I Get an Application to Vote by Mail?",
            description: `
                <a href='https://teamrv-mvp.sos.texas.gov/MVP/mvp.do' target='_blank' class='text-blue-300 underline'>Registered voters</a> may obtain an application by:
                <ul class='list-disc pl-6'>
                    <li>Downloading it from <a href='https://files.harrisvotes.com/harrisvotes/prd/docs/VotingInfo/2023%20Mail%20Ballot%20Application.pdf' target='_blank' class='text-blue-300 underline'>HarrisVotes.com/Voter/Vote By Mail</a></li>
                    <li>Calling 713.755.6965, or</li>
                    <li>Sending an email to <a href='mailto:vbm@HarrisVotes.com' target='_blank' class='text-blue-300 underline'>vbm@HarrisVotes.com</a></li>
                </ul>
            `
        },
        {
            title: "When Can I Apply to Vote by Mail?",
            description: `
                <div>By April 22, in order to send you a mail ballot for the May 3 Election.</div>
                
                <div>You can also drop off your application in-person to any of our 10 offices with a valid photo identification. <a href='https://www.harrisvotes.com/Contact-Us' target='_blank'  class='text-blue-300 underline'>Click here to find an election's office near you</a>.</div>
                
                <div>Due to potential delays with the postal service, PLEASE DO NOT WAIT – APPLY NOW!</div>
            `
        },
        {
            title: "What Qualifies as Having a Disability,And What Does That Mean In The Age Of Coronavirus (COVID-19) ?",
            description: `
                <div>Under Texas law, you qualify as having a disability if you are (1) sick, (2) pregnant, or (3) if voting in person will create a likelihood of injury to your health.<div>
                
                <div class='mt-3'>The Texas Supreme Court has ruled that lack of immunity to COVID-19 can be considered as a factor in your decision as to whether voting in person will create a likelihood of injury to your health, but it cannot be the only factor. You do not qualify to vote by mail as "disabled" if you have a fear of contracting COVID-19 but are otherwise healthy. To qualify, you must have an accompanying physical condition.</div>
            `
        },
        {
            title: "Will My Vote by Mail Ballot Count If I Choose Not to Vote on Certain Issues or Candidates?",
            description: `
                Yes. All the votes you cast will be counted. You have the right to skip any measure or contest.
            `
        },
        {
            title: "When Is My Vote by Mail Ballot Counted?",
            description: `
                Your Vote by Mail ballot is counted when voting centers close at 7:00 PM. on Election Day. At that time, all Vote by Mail ballots will be tabulated and submitted into the official record. The total number of votes cast by mail are included in the final tally.
            `
        },
        {
            title: "How Does The Harris County Clerk's Office Elections Department Process My Vote By Mail Ballot Securely?",
            description: `
                <div>When your completed Vote by Mail ballot is received at our office, it goes through a rigorous validation system.</div>
                
                <div class='mt-3'>The Carrier Envelope is verified for signature authentication, logged, and securely stored. Your Vote by Mail ballot is not counted until voting centers close at 7:00 PM. on Election Day. At that time, all Vote by Mail ballots will be tabulated and submitted into the official record.</div>
            `
        },
        {
            title: "Who Can Vote by Mail?",
            description: `
                You are <a href='https://www.sos.texas.gov/elections/voter/reqabbm.shtml' target='_blank' class='text-blue-300 underline'>eligible to Vote By Mail</a> in Texas if:
                <ol class='list-decimal pl-6'>
                    <li>You are age 65 or older by Election Day;</li>
                    <li>You will be outside of Harris County for all of the Early Voting period and on Election Day;</li>
                    <li>You are confined in jail but otherwise eligible to vote; or</li>
                    <li>You have a disability.</li>
                </ol>
            `
        },
        {
            title: "Can I Receive Assistance with Filling Out the Vote by Mail Application?",
            description: `
                Yes, <a href='https://statutes.capitol.texas.gov/Docs/EL/htm/EL.84.htm' target='_blank' class='text-blue-300 underline'>you may receive assistance</a> in completing and submitting your application from a friend or a relative. Your assistant MUST carefully review the instructions and complete the additional WITNESS/ASSISTANT section of the application.
            `
        },
        {
            title: "How Can I Check If My Vote by Mail Ballot Has Been Mailed or Received?",
            description: `
                Please visit <a href='https://www.harrisvotes.com/Voter/Mail-Ballot-Tracking' target='_blank' class='text-blue-300 underline'>Mail Ballot Tracking</a> to find out the status of your vote-by-mail application. For additional assistance, please call our Election Help Line at 713.755.6965.
            `
        },
        {
            title: "Can I Change My Vote After I Vote by Mail?",
            description: `
                If you have returned your completed Vote by Mail Ballot, you cannot vote in person to change your vote.
            `
        },
        {
            title: "How Is My Signature Verified?",
            description: `
                The voter's signature on the Vote by Mail ballot return envelope is compared to the signature from your Vote by Mail application and/or your voter registration application to maintain voter integrity.
            `
        }
    ];
    const primaryElection = [
        {
            title: "Who Is Eligible to Vote in a Primary Election in Harris County?",
            description: "Any person that is registered to vote in Harris County may vote in either the Republican Primary Election or the Democratic Primary Election (NOT both). In Texas, a person must register to vote 30 days before Election Day, if never registered to vote."
        },
        {
            title: "What Is a Primary Election?",
            description: "In Texas, primary elections are conducted by the major political parties to determine their nominees for a given elective office in advance of a general election."
        },
        {
            title: "Are Candidates Identified by Political Party on a Primary Election Ballot?",
            description: "No. In a Primary Election, all candidates are affiliated with the same major political party."
        },
        {
            title: "May a Registered Voter Participate in a Primary Election Runoff Even If the Voter Did Not Vote in the Primary Elections?",
            description: "Yes. It is not necessary to have voted in the Primary to vote in a Primary Runoff Election. However, during an election cycle, a voter that participated in a Primary Election may ONLY participate in the Primary Runoff Election of the Party in which the voter initially voted."
        },
        {
            title: "Is Straight Party Voting Available on a Primary Election Ballot?",
            description: "Straight Party voting is the practice of choosing the Straight Party option on the ballot and by this means casting a vote for all candidates of the same political party. This option is NOT available on a Primary Election ballot."
        },
        {
            title: "What Contests Are on the Primary Ballot?",
            description: "Typically, Federal, State and County contests appear on the Primary Election ballot. Political Parties may also offer nonbinding propositions."
        }
    ]
    return(
        <>
            <Header1/>
                <Banner title="FAQ'S FOR ELECTIONS" backgroundImage={'/faqBanner.png'} responsiveImage={'/faqBannerResponsive.png'} mobileImage={'/faqBannerMobile.png'} />
                <div className="w-full flex flex-col justify-center lg-xl:mt-20 lg:mt-15 mt-10 font-fira"> 
                    <div className="mb-[20px] md:mb-[60px]">
                        <FAQSection title="Voting Process" faqData={votingProcess} />
                    </div>
                    <div className="mb-[20px] md:mb-[60px]">
                        <FAQSection 
                            title="Early Voting" 
                            faqData={earlyVoting}  
                            introduction="<b>EARLY VOTING IN-PERSON: LIMITED BALLOT</b>  A registered voter in the state of Texas may qualify to vote a limited ballot at the main early voting site during the early voting period in a federal and state election. For more information see section 112.001 to 112.0012 of the Texas Election Code."
                        />
                    </div>
                    <div className="mb-[20px] md:mb-[60px]">
                        <FAQSection 
                            title="Election Day" 
                            faqData={electionDay}
                        />
                    </div>
                    <div className="mb-[20px] md:mb-[60px]">
                        <FAQSection 
                            title="Voting By Mail" 
                            faqData={votingByMail}
                        />
                    </div>
                    <div className="mb-[20px] md:mb-[60px]">
                        <FAQSection 
                            title="Primary Election" 
                            faqData={primaryElection}
                        />
                    </div>
                </div>
            <Footer/>
        </>
    )
}

export default FAQ;